module.exports = __webpack_public_path__ + "static/hero-aba86d2fb17b5ed6802f01774cfd9fda.png";